import React from "react";
import { Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { Link } from "react-router-dom";
import { DetailsValueLinkType, getSearchURL } from "../../../title/SearchLink";

export const LSResultItemAuthor = ({
  shortAuthor,
}: {
  shortAuthor: string;
}) => {
  const { translate } = useLanguage();

  if (!shortAuthor) {
    return null;
  }

  const authorLink = getSearchURL(shortAuthor, DetailsValueLinkType.author);

  return (
    <Typography component="h4">
      {translate("by")} <Link to={authorLink}>{shortAuthor}</Link>
    </Typography>
  );
};
